export const magicMobileMinWidth = 500;
